if (!customElements.get('code-cart-form')) {
  customElements.define(
  'code-cart-form',
  class CodeCartForm extends HTMLElement {
    async connectedCallback() {
      const sectionId = this.getAttribute('data-section-id');

      this.unsubscribe = subscribe('cartUpdate', ({ sections = {} }) => {
        if (!sections) return;

        const section = sections[sectionId];
        if (!section) return;

        if (section) {
          const newCartForm = new DOMParser()
            .parseFromString(section, 'text/html')
            .querySelector(this.tagName.toLowerCase());

          this.replaceWith(newCartForm);
        }

        this.toggleAttribute('data-loading', false);
      });
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
    }
  });
}
